import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import { message } from 'antd';
import {
	addSavedFiltersToState,
	getFilterRefinementDefinitionToSave,
	getBrowseFiltersByType,
} from '../../Community/util';
import { connectToSavedFilters } from './SavedFiltersDataStore';

const SavedFilterContext = React.createContext();

export const useSavedFilter = () => React.useContext(SavedFilterContext);

const name = 'savedFilterDataStore';

export const connectToSavedFilter = makeConnectTo(SavedFilterContext, name);

export class SavedFilterDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		savedFilter: [],
		viewId: 0,
		titleCount: -1,
		newId: 0,
		isLoading: true,
	};

	render() {
		const savedFilterDataStore = this.getStore();
		return (
			<SavedFilterContext.Provider value={savedFilterDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(savedFilterDataStore)
					: this.props.children}
			</SavedFilterContext.Provider>
		);
	}

	componentDidMount() {
		this.props.getCount ? this.fetchTitleCount() : this.fetchSavedFilter();
	}

	componentWillUnmount() {
		if (this.savedFilterFetch && this.savedFilterFetch.cancel) {
			this.savedFilterFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshSavedFilter(),
		refreshTitleCount: () => this.refreshTitleCount(),
		updateFilters: savedFilter => this.updateFilters(savedFilter),
		saveFilters: (activeCategories, browseLaneType) =>
			this.saveFilters(activeCategories, browseLaneType),
		resetNewId: () => this.resetNewId(),
	});

	refreshSavedFilter = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchSavedFilter();
		return this.savedFilterFetch.promise;
	};

	fetchSavedFilter = () => {
		const { viewId } = this.props;
		const request = api.cancelableGet(`/api/v1/filters/${viewId}/titles`);
		request.promise.then(this.cacheFullApiResponse);
		this.savedFilterFetch = request;
	};

	cacheFullApiResponse = apiResponse => {
		const { viewId } = this.props;
		const savedFilter = this.getSavedFilter(apiResponse);
		this.setState({ savedFilter, isLoading: false, viewId });
	};

	getSavedFilter = apiResponse => {
		const {
			products,
			digitalCopyInfo,
			requestableSkus,
			downloadableSkus,
			userCommunitySummaryReviews,
		} = apiResponse;
		if (products) {
			return products.map(product => {
				const availableReviewCopyFormats = digitalCopyInfo.filter(
					dci => dci.sku === product.sku,
				);
				const isRequestable =
					requestableSkus &&
					requestableSkus.filter(rs => rs === product.sku)[0];
				const isDownloadable =
					downloadableSkus &&
					downloadableSkus.filter(dl => dl === product.sku)[0];
				product.digitalUpdatedDate =
					availableReviewCopyFormats &&
					availableReviewCopyFormats.length > 0 &&
					availableReviewCopyFormats[0].updatedDate;
				product.reviewCopyAvailability = isDownloadable
					? 'Available for Download'
					: isRequestable
					? 'Available for Request'
					: 'Review Copy Not Available';
				const csr = userCommunitySummaryReviews.filter(
					csr => csr.sku === product.sku,
				);
				var reviews = 0;
				var average = 0;
				if (csr && csr.length > 0) {
					reviews = csr[0].count;
					average = csr[0].rating && csr[0].rating.toFixed(1);
				}
				product.reviews = reviews;
				product.average = average;
				return {
					...product,
					product,
					isRequestable,
					isDownloadable,
					availableReviewCopyFormats,
					uri:
						product &&
						product.images &&
						product.images.filter(im => im.type === 'jacketCover')
							.length > 0 &&
						product.images.filter(
							im => im.type === 'jacketCover',
						)[0].uri + '?height=450',
				};
			});
		}
	};

	refreshTitleCount = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchTitleCount();
		return this.savedFilterFetch.promise;
	};

	fetchTitleCount = () => {
		const { viewId } = this.props;
		const { newId } = this.state;
		const request = api.cancelableGet(
			`/api/v1/filters/${newId > 0 ? newId : viewId}/titles/count`,
		);
		request.promise.then(this.cacheApiResponse);
		this.savedFilterFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const titleCount = apiResponse;
		this.setState({ titleCount, isLoading: false });
	};

	updateFilters = savedFilter => {
		const { newId } = this.state;
		const id = newId > 0 ? newId : savedFilter.id;
		const definition = getFilterRefinementDefinitionToSave(
			savedFilter.browseRefinements,
		);
		const userBrowseView = {
			name: savedFilter.name,
			id: id,
			definition: JSON.stringify(definition),
		};
		if (id === -1) {
			api.post('/api/v1/savedFilters', userBrowseView)
				.then(newId => {
					this.setState({ newId });
					this.refreshTitleCount();
					message.success('Your changes have been saved');
				})
				.catch(e => console.error(e));
		} else {
			api.put('/api/v1/savedFilters', userBrowseView)
				.then(() => {
					this.refreshTitleCount();
					message.success('Your changes have been saved');
				})
				.catch(e => console.error(e));
		}
	};

	saveFilters = (activeCategories, browseLaneType) => {
		var { savedFilters } = this.props.savedFiltersDataStore.state;
		const { viewId } = this.props;
		var thisSavedFilter = savedFilters.filter(sf => sf.id === viewId)[0];
		thisSavedFilter.browseRefinements = thisSavedFilter.browseRefinements.filter(
			tsf => tsf.browseLaneType !== browseLaneType.key,
		);
		addSavedFiltersToState(
			thisSavedFilter.browseRefinements,
			activeCategories,
			browseLaneType,
			viewId,
		);
		thisSavedFilter.filtersByType = getBrowseFiltersByType(thisSavedFilter);
		this.updateFilters(thisSavedFilter);
	};

	resetNewId = () => {
		this.setState({ newId: 0 });
	};
}

export default connectToSavedFilters(SavedFilterDataStore);
